<template>
  <v-app>
    <v-fade-transition>
      <div class="splash-screen" v-if="splashScreen">
        <img src="./assets/logo.png" class="logo" alt="logo" />
        <!-- <img src="/Ripple-2s-200px.gif" alt="loading-image"> -->
      </div>
    </v-fade-transition>
    <StartBreak v-if="isBreakActive" />

    <router-view />

    <!-- NOTIFICACIONES -->
    <vue-snotify></vue-snotify>

    <!-- <v-speed-dial
      fixed
      right
      bottom
      v-model="fab"
      direction="top"
      transition="slide-y-reverse-transition"
      style="z-index: 2000"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>

      <v-btn fab dark small color="indigo">
        <v-icon>mdi-video</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" @click="activeFloatingChat">
        <v-icon>mdi-chat</v-icon>
      </v-btn>
    </v-speed-dial> -->

    <!-- <floating-chat :isActive="FloatingChat" @dialog:close="closeFloatingChat" /> -->
  </v-app>
</template>

<script>
// import FloatingChat from "@/components/core/FloatingChat.vue";
import StartBreak from "@/components/Utils/StartBreak";
/**
 * This was used with the websocket method
 */
// import Echo from "laravel-echo";
// window.Pusher = require("pusher-js");

export default {
  name: "App",
  mounted() {
  /**
     * This was used with the websocket method
     */
    // window.Echo = new Echo({
    //   broadcaster: "pusher",
    //   key: "POTR2525",
    //   wsHost: "c101.pbxberry.com",
    //   wsPort: 6001,
    //   wssPort: 6001,
    //   disableStats: true,
    //   forceTLS: false,
    // });

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("firebase-messaging-sw.js")
        .catch((error) => {
          const msg = `Service Worker Error (${error})`;
          console.error(msg);
        });
    } else {
      // happens when the app isn't served over HTTPS or if the browser doesn't support service workers
      console.warn("Service Worker not available");
    }

    this.$messaging.onMessage(({ notification }) => {
      const { body } = notification;
      const bodyParsed = JSON.parse(body)
      let notifMessage = "";
      if (typeof bodyParsed === "string") notifMessage = body;
      if (typeof bodyParsed === "object") {
        if (body.ticket?.userId === null) notifMessage = "Nuevo chat en cola";
        else notifMessage = "Nuevo mensaje de chat.";
      }
      this.$snotify.info(notifMessage, notification.title);

      this.$store.dispatch("triggerRefreshChats");
      // this.$root.$emit('refresh-chat-panel');
      // console.log('refresh-chat-panel');
    });
  },
  components: {
    StartBreak,
    // FloatingChat,
  },
  data: () => ({
    fab: false,
    // FloatingChat: false,
  }),

  computed: {
    splashScreen() {
      return this.$store.getters.splashScreen;
    },

    isBreakActive() {
      return this.$store.getters["breaks/GET_IS_BREACK_ACTIVE"];
    },
  },

  // methods: {
  //   activeFloatingChat(item) {
  //     this.FloatingChat = true;
  //     // this.fab = false;
  //   },

  //   closeFloatingChat(value) {
  //     this.FloatingChat = false;
  //   },
  // },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;800&display=swap");
@import "./assets/styles/index.scss";

#app {
  font-family: "Poppins", sans-serif !important;
  word-break: normal !important;
  line-height: normal !important;
}

.theme--light.v-application {
  background: #eff0f8 !important;
  // background: #e8e7e7 !important;
  color: #495057 !important;
}
</style>
